import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/checkmark-white.svg'
import _imports_1 from '@/assets/icons/chevron-forward-gray.svg'


const _hoisted_1 = { class: "flex flex-col h-screen" }
const _hoisted_2 = { class: "flex-grow bg-background shadow-inner" }
const _hoisted_3 = { class: "container h-full py-8" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col h-full justify-between"
}
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex flex-row justify-between w-full" }
const _hoisted_8 = { class: "flex flex-col items-start" }
const _hoisted_9 = { class: "capitalize" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_11 = { class: "flex flex-row items-end mt-4" }
const _hoisted_12 = {
  key: 0,
  class: "text-3xl font-bold"
}
const _hoisted_13 = {
  key: 1,
  class: "text-3xl font-bold"
}
const _hoisted_14 = { class: "uppercase font-bold ml-2" }
const _hoisted_15 = { class: "flex flex-row justify-between items-center w-full mt-4" }
const _hoisted_16 = { class: "flex flex-row items-center font-semibold" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  src: _imports_0,
  class: "w-3 h-3"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "mx-4"
}, null, -1)
const _hoisted_22 = { class: "flex flex-col items-end justify-between" }
const _hoisted_23 = {
  key: 0,
  class: "bg-orange-100 text-orange-400 rounded-full px-4 py-2"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "flex flex-row items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_ErrorState = _resolveComponent("ErrorState")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_DateFormatter = _resolveComponent("DateFormatter")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navbar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.error)
                  ? (_openBlock(), _createBlock(_component_ErrorState, { key: 0 }))
                  : _createCommentVNode("", true),
                (!_ctx.error && _ctx.payrolls.length === 0)
                  ? (_openBlock(), _createBlock(_component_EmptyState, {
                      key: 1,
                      name: "payrolls"
                    }))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activePayrolls.slice(), (payroll, i) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: i,
                    onClick: ($event: any) => (_ctx.$router.push(`/payroll/${payroll.id}`)),
                    class: _normalizeClass(["flex flex-col bg-white shadow rounded-2xl p-8 items-start justify-start", {
                'border border-primary':
                  payroll.stripe_invoice_status === 'in_process',
                'mt-4': i > 0,
              }])
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, [
                          _createTextVNode(_toDisplayString(payroll.company.visible_name) + " Payroll: ", 1),
                          _createVNode(_component_DateFormatter, {
                            date: payroll.start_date
                          }, null, 8, ["date"]),
                          _hoisted_10,
                          _createVNode(_component_DateFormatter, {
                            date: payroll.end_date
                          }, null, 8, ["date"])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createTextVNode(_toDisplayString(payroll.payrolls_exchange_rate_mxn) + " ", 1),
                          (_ctx.currency === 'usd')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, " $" + _toDisplayString((payroll.payrolls_total / 100).toLocaleString(
                          undefined,
                          { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                        )), 1))
                            : (_ctx.currency === 'mxn')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, " $" + _toDisplayString((
                          (payroll.payrolls_total * payroll.exchange_rate) /
                          100
                        ).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })), 1))
                              : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.currency), 1)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            (payroll.stripe_invoice_status === 'not_created')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Estimate "))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", {
                              class: _normalizeClass(["flex items-center justify-center w-6 h-6 rounded-full mr-4", {
                          'bg-secondary':
                            payroll.stripe_invoice_status === 'in_process',
                          'bg-green-500':
                            payroll.stripe_invoice_status === 'paid',
                        }])
                            }, [
                              (payroll.stripe_invoice_status === 'paid')
                                ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                                : _createCommentVNode("", true)
                            ], 2),
                            (payroll.stripe_invoice_status === 'in_process')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, " Waiting for automatic payment "))
                              : _createCommentVNode("", true),
                            (payroll.stripe_invoice_status === 'paid')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, " Paid "))
                              : _createCommentVNode("", true),
                            _hoisted_21,
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-6 h-6 bg-gray-200 rounded-full mr-4", {
                          'bg-secondary':
                            payroll.stripe_invoice_status === 'paid',
                        }])
                            }, null, 2),
                            _createElementVNode("span", {
                              class: _normalizeClass({
                          'text-gray-400':
                            payroll.stripe_invoice_status === 'in_process',
                          'text-automatic':
                            payroll.stripe_invoice_status === 'paid',
                        })
                            }, " Pay stubs delivered ", 2)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        (payroll.pending_reimbursement_clarifications)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, " Pending clarification "))
                          : (_openBlock(), _createElementBlock("div", _hoisted_24)),
                        _createElementVNode("div", _hoisted_25, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payroll.users.slice(0, 5), (emp, j) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: j,
                              class: "flex justify-center items-center bg-primary text-white rounded-full w-10 h-10 mx-2"
                            }, _toDisplayString(emp.first_name[0]) + _toDisplayString(emp.last_name[0]), 1))
                          }), 128))
                        ])
                      ])
                    ])
                  ], 10, _hoisted_6))
                }), 128))
              ]),
              _createVNode(_component_Paginator, {
                modelValue: _ctx.nextPage,
                page: _ctx.nextPage,
                pages: _ctx.pagination.total_pages,
                "range-size": 1,
                "onUpdate:modelValue": _ctx.updateHandler,
                total: _ctx.pagination.total_count,
                from: _ctx.pagination.from,
                to: _ctx.pagination.to,
                class: "mt-8"
              }, null, 8, ["modelValue", "page", "pages", "onUpdate:modelValue", "total", "from", "to"])
            ]))
      ])
    ])
  ]))
}